export function hasDoctype(text: string): boolean {
	try {
		// check if DOMParser is available (browser environment)
		if (typeof DOMParser === 'undefined') {
			// fallback for non-browser environments
			return false;
		}

		const parser = new DOMParser();
		const doc = parser.parseFromString(text, 'text/html');
		return doc.doctype !== null;
	} catch {
		return false;
	}
}
